import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import { PLPPages } from '@/app/(plp)/types';
interface Props {
  initialPage: PLPPages;
}
const NextLevelCategoriesLoading = ({
  initialPage
}: Props) => {
  const {
    page: plpFacetsPage
  } = usePLPFacetsContext();
  const page = initialPage || plpFacetsPage;
  if (page !== PLPPages['Categories']) return null;
  return <div className='mb-4 h-7 w-full animate-pulse rounded bg-gray-100 lg:my-2 lg:mb-3 lg:h-30' data-sentry-component="NextLevelCategoriesLoading" data-sentry-source-file="loading.tsx" />;
};
export default NextLevelCategoriesLoading;